var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "18", height: "18", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M1.65 8.33l6.676-6.673a5.678 5.678 0 0 1 8.017 0c2.21 2.208 2.21 5.795 0 8.013l-6.676 6.673c-2.22 2.21-5.807 2.21-8.017 0-2.2-2.208-2.2-5.786 0-8.013zm1.341 1.34a3.752 3.752 0 0 0-.982 3.644l5.656-5.645 4.004 4.002 3.333-3.341a3.753 3.753 0 0 0 0-5.333 3.757 3.757 0 0 0-5.335 0L2.99 9.67z", fill: "#142A39" })
  );
});